module.exports = __webpack_public_path__ + "img/primary_5x3.f9cf0ad2.svg";